document.addEventListener('DOMContentLoaded', () => {
  const carbonParallaxSection = document.querySelector('.carbon-parallax');
  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (carbonParallaxSection && !isMobile) {
    const background = carbonParallaxSection.querySelector('.carbon-parallax-background-container');
    const overlayContent = carbonParallaxSection.querySelector('.carbon-parallax-overlay-content-container');

    const getParallaxConfig = () => ({
      backgroundStart: -720,
      backgroundSpeed: 1600,
      overlayStart: 50,
      overlaySpeed: 90,
    });

    const updateParallax = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      const sectionTop = carbonParallaxSection.offsetTop;
      const sectionHeight = carbonParallaxSection.offsetHeight;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const start = sectionTop - viewportHeight;
      const end = sectionTop + sectionHeight;
      const progress = end > start ? Math.min(Math.max((scrollY - start) / (end - start), 0), 1) : 0;

      const config = getParallaxConfig();

      if (background) {
        const backgroundOffset = config.backgroundStart + progress * config.backgroundSpeed;
        if (backgroundOffset >= 0 && window.innerWidth <= 1700) {
        } else {
          background.style.top = `${Math.round(backgroundOffset)}px`;
        }
      }

      if (overlayContent) {
        const overlayOffset = config.overlayStart - progress * config.overlaySpeed;
        if (overlayOffset <= 0) {
          overlayContent.style.bottom = `0%`;
        } else {
          overlayContent.style.bottom = `-${overlayOffset}%`;
        }
      }
    };

    window.addEventListener('scroll', updateParallax);
    window.addEventListener('resize', updateParallax);
    updateParallax();
  }
});
